import React, { useState } from 'react';

import benefitIcon from '../../images/pristyn-care/pristyn-benefit-icon.png';
import testimonial1 from '../../images/pristyn-care/testimonial1.png';
import testimonial2 from '../../images/pristyn-care/testimonial2.png';
import testimonial3 from '../../images/pristyn-care/testimonial3.png';
// import arrow from '../../images/pristyn-care/arrow.png';

import eyeIcon from '../../images/pristyn-care/conditions/eye.svg';
import lasik from '../../images/pristyn-care/conditions/lasik.svg';
import ortho from '../../images/pristyn-care/conditions/ortho.svg';
import gallstone from '../../images/pristyn-care/conditions/gallstone.svg';
import kneereplacement from '../../images/pristyn-care/conditions/kneereplacement.svg';
import kidneystone from '../../images/pristyn-care/conditions/kidneystone.svg';
import hair from '../../images/pristyn-care/conditions/hair.svg';
import liposuction from '../../images/pristyn-care/conditions/liposuction.svg';
import varicoseveins from '../../images/pristyn-care/conditions/varicosevein.svg';

import working1 from '../../images/pristyn-care/workings/working1.png';
import working2 from '../../images/pristyn-care/workings/working2.png';
import working3 from '../../images/pristyn-care/workings/working3.png';
import working4 from '../../images/pristyn-care/workings/working4.png';

import whyVisit1 from '../../images/pristyn-care/whyVisit/whyVisit1.svg';
import whyVisit2 from '../../images/pristyn-care/whyVisit/whyVisit2.svg';
import whyVisit3 from '../../images/pristyn-care/whyVisit/whyVisit3.svg';
import whyVisit4 from '../../images/pristyn-care/whyVisit/whyVisit4.svg';

import Benefits from './benefits';
import FormInput from './formInput';
import SelectInput from './selectInput';
import Card from './card';
import Label from './Label';
import Container from './container';
import ConditionIcon from './conditionIcon';
import WorkingCard from './workingCard';
import WhyVisit from './whyVisit';
import TestimonialCard from './testimonialCard';
import config from '../../config';
import VisitHeader from '../common/header';

const DEFAULT_DATA = {
  patient: '',
  procedure: '',
  phone: '',
  location: '',
};
const PristynCareForm = (props) => {
  const [data, setData] = useState(DEFAULT_DATA);
  const [error, setError] = useState(DEFAULT_DATA);

  const submitForm = (data) => {
    console.log(data);
    const body = {
      'Employee Name': data.patient,
      'Employee Phone number': data.phone,
      'Patient Name': data.patient,
      City: data.location,
      Diagnosis: data.procedure,
    };
    fetch(`${config.apiBaseUrl}/pristyn-care/add-post-consultation-data`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Success:', data);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  return (
    <div
      className="w-full h-500 font-mont overflow-scroll"
      style={{ background: 'white' }}
    >
      <div className="header">
        <div className="w-full">
          <VisitHeader showMenu={true} />
        </div>
      </div>
      <div className="body mt-40px">
        <div
          style={{
            background: 'linear-gradient(180deg, #FFFFFF 0%, #EFE9F F 100%)',
          }}
        >
          <Container>
            <div className="mt-0px">
              <p
                style={{
                  color: '#714FFF',
                  fontFamily: 'var(--font-secondary)',
                  fontWeight: 600,
                  letterSpacing: '1px',
                }}
              >
                SURGERY CARE
              </p>
              <Label title="Your Visit for Surgical Care!" />
              <Benefits text="End to End Care till recovery with a dedicated Care Buddy" />
              <Benefits text="Free Consult with the right expert for your condition & treatment" />
              <Benefits text="Easy Financing & Insurance paperwork" />
              <Benefits text="Hassle-free pre & post operative process" />
              <img
                src={benefitIcon}
                style={{ paddingTop: '20px' }}
                alt="benefitIcon"
              />
            </div>
          </Container>
        </div>
        <div
          style={{
            marginTop: '-155px',
            backgroundColor: 'white',
            paddingTop: '30px',
            position: 'relative',
          }}
        >
          <Container>
            <div
              style={{
                border: ' 1px solid #C8C8C8',
                borderRadius: '14px',
              }}
            >
              <p
                style={{
                  color: '#0D2059',
                  padding: '20px',
                  borderRadius: '14px 14px 0px 0px',
                  backgroundColor: '#F3EEFF',
                  fontWeight: 600,
                }}
              >
                Book Free Consultation
              </p>
              <FormInput
                title="Patient’s Name"
                onChange={setData}
                name="patient"
                placeholder="Enter Patient’s Name"
                value={data.patient}
                error={error.patient}
              />
              <SelectInput
                title="Select Procedure"
                onChange={setData}
                name="procedure"
                value={data.procedure}
                error={error.procedure}
              />
              <FormInput
                title="Phone Number"
                onChange={setData}
                name="phone"
                placeholder="Enter Phone Number"
                value={data.phone}
                error={error.phone}
              />
              <FormInput
                title="Location"
                onChange={setData}
                placeholder="Enter Location"
                name="location"
                value={data.location}
                error={error.location}
              />
              <div
                style={{
                  fontFamily: 'var(--font-secondary)',
                  fontWeight: 600,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  padding: '20px',
                  justifyContent: 'center',
                }}
              >
                <p
                  style={{
                    backgroundColor: '#714FFF',
                    color: '#FFFFFF',
                    borderRadius: '14px',
                    textAlign: 'center',
                    fontSize: '18px',
                    padding: '10px 20px',
                    width: '95%',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    console.log('clicked');
                    const error = {};
                    Object.keys(data).forEach((key) => {
                      if (!data[key] && key !== 'procedure') {
                        error[key] = `${key} field is required`;
                      }
                    });
                    if (Object.keys(error).length) {
                      setError(error);
                    } else {
                      setError(DEFAULT_DATA);
                      submitForm(data);
                    }
                  }}
                >
                  Book Free Consultation
                </p>
                <p
                  style={{
                    color: '#515151',
                    fontSize: '12px',
                    paddingTop: '8px',
                    lineHeight: '16px',
                    textAlign: 'center',
                    width: '87%',
                  }}
                >
                  By proceeding to submit, you agree to our{' '}
                  <span href="void">Terms & Conditions</span>
                </p>
              </div>
            </div>
          </Container>
        </div>
        <Container>
          <div className="grid grid-cols-2 mt-0 gap-3">
            <Card count="50+" text={'Conditions'} />
            <Card count="30+" text={'Cities'} />
            <Card count="300+" text={'Hospitals'} />
            <Card count="500+" text={'Surgeons'} />
          </div>
        </Container>
        <Container>
          <Label title="Conditions we treat" />
          <div
            style={{
              border: ' 1px solid #C8C8C8',
              borderRadius: '14px',
              marginTop: '20px',
              boxShadow:
                '0px 6px 14px -6px rgba(24, 39, 75, 0.12), 0px 10px 32px -4px rgba(24, 39, 75, 0.1)',
              position: 'relative',
            }}
          >
            <div className="grid grid-cols-3 mt-0 gap-8 p-8">
              <ConditionIcon icon={eyeIcon} condition="Cataract" />
              <ConditionIcon icon={lasik} condition="Lasik" />
              <ConditionIcon icon={ortho} condition="Ortho" />
              <ConditionIcon icon={gallstone} condition="Gallstone" />
              <ConditionIcon
                icon={kneereplacement}
                condition="Knee Replacement"
              />
              <ConditionIcon icon={kidneystone} condition="Kidney Stone" />
              <ConditionIcon icon={hair} condition="Hair" />
              <ConditionIcon icon={liposuction} condition="Liposuction" />
              <ConditionIcon icon={varicoseveins} condition="Varicose Veins" />
            </div>
            {/* <div
              style={{
                position: 'absolute',
                bottom: '0px',
                left: '50%',
                borderRadius: '14px',
                padding: '10px',
                cursor: 'pointer',
                transform: 'translate(-50%, 50%)',
                border: '1px solid #714FFF',
                width: '100px',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <span
                style={{
                  color: '#714FFF',
                  fontWeight: 600,
                  fontSize: '14px',
                  fontFamily: 'var(--font-secondary)',
                }}
              >
                View all
              </span>
              <span>
                <img
                  src={arrow}
                  alt="arrow"
                  style={{
                    marginLeft: '10px',
                  }}
                />
              </span>
            </div> */}
          </div>
        </Container>
        <div
          style={{
            paddingTop: '40px',
            background:
              'linear-gradient(180deg, #ECEFF0 0%, rgba(255, 255, 255, 0) 10%)',
          }}
        >
          <Container>
            <Label title="How it Works" />
            <div
              className="grid grid-cols-2 mt-20px gap-8"
              style={{ marginTop: '30px' }}
            >
              <WorkingCard
                icon={working1}
                text="FREE first consult with an expert"
                desc="A Dedicated Care Buddy will reach out to understanding"
              />
              <WorkingCard
                icon={working2}
                text="Financial Counseling & EMI Support"
                desc="Help you with insurance paperwork and support you"
              />
              <WorkingCard
                icon={working3}
                text="Hassle-free admission & discharge"
                desc="Continuous support during the admission process ..."
              />
              <WorkingCard
                icon={working4}
                text="Post-Surgery Care"
                desc="Regular check-ins from a dedicated nurse, help ..."
              />
            </div>
          </Container>
        </div>
        <div
          style={{
            paddingTop: '40px',
            background:
              'linear-gradient(180deg, #ECEFF0 0%, rgba(255, 255, 255, 0) 100%)',
          }}
        >
          <Container>
            <Label title="Why VISIT Surgery Care?" />
            <div
              style={{
                marginTop: '30px',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <WhyVisit
                icon={whyVisit1}
                title="Enhanced Quality of Care"
                desc="Constant support, a network of premium hospitals and top-tier surgeons."
              />
              <WhyVisit
                icon={whyVisit2}
                title="Continuous Guidance"
                desc="Fingertip-access to all the information you will need. Any problem you may face resolved with one phone call."
              />
              <WhyVisit
                icon={whyVisit3}
                title="End-to-End Management"
                desc="Your only focus should be to go and get your procedure done. Leave the rest to us."
              />
              <WhyVisit
                icon={whyVisit4}
                title="Lower Costs and easy financing support"
                desc="HealthCare can be expensive. We bring you the best deals, EMI options and pricing models without compromising on quality"
              />
            </div>
          </Container>
        </div>
        <div
          style={{
            paddingTop: '40px',
            background:
              'linear-gradient(180deg, #ECEFF0 0%, rgba(255, 255, 255, 0) 10%)',
            marginBottom: '40px',
          }}
        >
          <Container>
            <Label title="Our users love us" />
            <div
              style={{
                marginTop: '30px',
                display: 'flex',
                overflowX: 'scroll',
                overflowY: 'hidden',
                paddingBottom: '20px',
              }}
            >
              <TestimonialCard
                name="Ravi Sinha"
                location="Corporate User"
                userIcon={testimonial1}
                title=""
                desc="A superb App, great to have expert opinion at your fingertips. Give u comfort to express your problem properly. Response is electric fast and detailed."
              />
              <TestimonialCard
                name="Manish Sirhindi"
                location="Corporate User"
                userIcon={testimonial2}
                title=""
                desc="One of the best app that I have come across. It provide me instant consultation with medical experts in my time of need. A must recommend app."
              />
              <TestimonialCard
                name="Nakul Maheshwari"
                location="Visit User"
                userIcon={testimonial3}
                title=""
                desc="The app is amazing, all the specialist also seems to be pretty good. it's amazing if you can get a professional advice without actually taking the trouble of going out in traffic and waiting in a queue for hours."
              />
            </div>
          </Container>
        </div>
        {/* <div
          style={{
            backgroundColor: '#F8FAFF',
            paddingTop: '40px',
            paddingBottom: '40px',
          }}
        >
          <Container>
            <div
              style={{
                position: 'relative',
                margin: '0 -20px',
                borderBottom: '1px solid #C8C8C8',
              }}
            >
              <img
                src={visitLogo}
                alt="logo"
                style={{
                  width: '78px',
                  height: '32.27px',
                  margin: '0 20px',
                  marginBottom: '20px',
                }}
              />
            </div>
            <div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  flexDirection: 'row',
                  marginTop: '20px',
                  marginBottom: '20px',
                }}
              >
                <p
                  style={{
                    color: '#3976EA',
                    fontSize: '12px',
                    paddingRight: '20px',
                    marginRight: '10px',
                    fontWeight: 600,
                    borderRight: '2px solid #3976EA',
                  }}
                >
                  About Us
                </p>
                <p
                  style={{
                    color: '#3976EA',
                    fontSize: '12px',
                    marginRight: '20px',
                    paddingRight: '10px',
                    fontWeight: 600,

                    borderRight: '2px solid #3976EA',
                  }}
                >
                  Terms & Conditions
                </p>
                <p
                  style={{
                    color: '#3976EA',
                    fontSize: '12px',
                    marginRight: '20px',
                    fontWeight: 600,
                    paddingRight: '10px',
                    borderRight: '2px solid #3976EA',
                  }}
                >
                  Privacy Policy
                </p>
              </div>
              <p
                style={{
                  textAlign: 'center',
                  color: '#0D2059',
                  fontWeight: 600,
                  fontSize: '12px',
                  fontFamily: 'var(--font-secondary)',
                }}
              >
                Download the VISIT app
              </p>
            </div>
          </Container>
        </div> */}
      </div>
    </div>
  );
};

export default PristynCareForm;

/**
 * var magicForm = {
  'Employee Name': $('#employeeName').val(),
  'Employee Phone number': $('#employeePhoneNumber').val(),
  'Patient Name': $('#patientName').val(),
  'City': $('#address').val(),
  'Diagnosis': $('#diagnosis').val(),`
  };
  $.ajax({
  type        : 'POST',
  url         : '#{ baseUrl }pristyn-care/add-post-consultation-data',
  data        : magicForm,
  dataType    : 'json',
  encode      : true
  })
 */
